import React from "react";

interface MatrixGroupBandProps {
  label: string;
  sub: string;
  intro: string | null;
}

const MatrixGroupBand: React.FC<MatrixGroupBandProps> = ({
  label,
  sub,
  intro,
}) => (
  <>
    <div className="flex items-baseline gap-2.5 bg-gray-900 px-5 py-2 dark:bg-slate-900">
      <h2 className="text-[12.5px] font-semibold uppercase tracking-[0.1em] text-white">
        {label}
      </h2>
      <span className="text-[11.5px] text-gray-400">{sub}</span>
    </div>
    {intro && (
      <p className="border-b border-gray-100 bg-white px-5 py-2.5 text-[12.5px] leading-snug text-gray-500 dark:border-slate-700/50 dark:bg-slate-800 dark:text-gray-400">
        {intro}
      </p>
    )}
  </>
);

export default MatrixGroupBand;
